<template>
  <div>
    <div class="afdc-container-fluid" id="afdc-results-count" aria-live="polite">
      <template v-if="$route.path === '/find/nearest' && !hasResults"><div class="afdc-col-form-label afdc-mx-sm-1">{{ stationCountText }}</div></template>
      <select v-model="queryCountry" class="afdc-form-control afdc-custom-select">
        <option v-for="option in countryOptions" v-bind:key="option.key" v-bind:value="option.key">
          {{ option.name }}
        </option>
      </select>
    </div>

    <div class="afdc-container-fluid afdc-find-filters">
      <form v-on:submit.prevent class="afdc-tab-content">
        <div v-bind:class="{ 'afdc-tab-pane': true, 'afdc-active': isNavActiveFindModeNearest }">
          <find-nearest-filters/>
        </div>

        <div v-bind:class="{ 'afdc-tab-pane': true, 'afdc-active': isNavActiveFindModeRoute }">
          <find-route-filters/>
        </div>
      </form>

      <template v-if="$store.getters.getStationsError">
        <div class="afdc-stations-error">
          <p class="afdc-alert afdc-alert-warning"><em>{{ $store.getters.getStationsError }}</em></p>
        </div>
      </template>
    </div>

    <div class="afdc-row afdc-no-gutters">
      <div v-if="$store.getters.getLoadingStationPoints" class="afdc-large-spinner-container">
        <div class="afdc-large-spinner"></div>
      </div>

      <div v-if="$store.getters.getLoadingNearestStations" class="afdc-large-spinner-container">
        <div class="afdc-large-spinner"></div>
      </div>

      <div v-if="$store.getters.getLoadingRouteStations" class="afdc-large-spinner-container">
        <div class="afdc-large-spinner"></div>
      </div>

      <div v-if="hasResults" class="afdc-col-sm-3">
        <template v-if="isNavActiveFindModeRoute">
          <find-route-results/>
        </template>
        <template v-else>
          <find-nearest-results/>
        </template>
      </div>
      <div v-bind:class="mapWidthClass">
        <router-view v-if="$store.getters.isNavActiveTabFind"/>

        <map-stations v-if="$store.getters.isNavActiveTabFind"/>
      </div>
    </div>
  </div>
</template>

<script>
import FindNearestFilters from '@/components/FindNearestFilters.vue';
import FindRouteFilters from '@/components/FindRouteFilters.vue';
import FindNearestResults from '@/components/FindNearestResults.vue';
import FindRouteResults from '@/components/FindRouteResults.vue';
import MapStations from '@/components/MapStations.vue';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  name: 'FindStations',
  components: {
    FindNearestFilters,
    FindRouteFilters,
    FindNearestResults,
    FindRouteResults,
    MapStations,
  },

  data() {
    return {
      radius: this.$route.query.radius,
      index: true,
    };
  },

  computed: {
    queryCountry: syncInputRouteQuery('country'),

    isNavActiveFindModeNearest() {
      return this.$store.getters.isNavActiveFindModeNearest;
    },

    isNavActiveFindModeRoute() {
      return this.$store.getters.isNavActiveFindModeRoute;
    },

    stationCountText() {
      const count = this.$store.getters.stationPointCount;
      const text = this.$ngettext('%s result in', '%s results in', count);
      return this.$sprintf(text, this.$formatNumber(count));
    },

    mapWidthClass() {
      if (this.hasResults) {
        return 'afdc-col-sm-9';
      }
      return 'afdc-col-sm-12';
    },

    hasResults() {
      return this.$store.getters.hasNavStationResults;
    },

    countryOptions() {
      return this.$store.getters.loaderCountries;
    },
  },
};
</script>

<style lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/_mixins.scss';

.find-filters {
  z-index: 20;
  position: relative;

  background-color: #ccc;
  padding-top: ($grid-gutter-width / 2);

  // Limit the height of 100% height divs. I'm not sure how necessary this is,
  // but this is to deal with the theoretical possibility of our widget being
  // embedded on a page operating in quirk's mode.
  //
  // In quirks mode, 100% height divs occupy the entire height of the viewport,
  // which can make the widget filter area very tall. This is a bit of a kludge
  // and it isn't perfect, but this at least prevents all of the content from
  // being pushed off screen.
  //
  // See: https://stackoverflow.com/a/32215263/222487
  // https://www.pivotaltracker.com/story/show/159346997
  .h-100 {
    max-height: 300px;
  }
}

input.clearable-input {
  padding-right: 28px;
}

.clear-input {
  position: absolute;
  top: 0px;
  padding: 6px 0px;
  height: 24px;
  line-height: 24px;
  right: 50px;
  z-index: 20;
  font-size: 17px;
  color: #999;
  &:hover {
    color: #666;
    cursor: pointer;
  }
  &.clear-start-location {
    right: 65px;
  }
}

.input-group-append button {
  background-color: #eee;
  border: 1px solid #ccc;
  color: #666;
  &:hover {
    cursor: pointer;
    background-color: #fff;
    border: 1px solid #ccc;
    color: #666;
  }
}

a.switch-find-type:hover {
  text-decoration: none;
}

#switch-find-type {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1;
  border-radius: 10px;
  background-color: #eee;
  @media (min-width: 992px) {
    width: 80px;
  }
  @media (max-width: 992px) {
    width: 60px;
  }
  color: #666;
  box-shadow: 3px 3px 5px #aaa;
  margin-bottom: 15px;
  display: inline-block;

  &:hover {
    background-color: #fff;
  }

  img, .fa-icon {
    width: 13px;
    float: left;
    margin: 9px 5px 0 0;
    color: #666;
    font-size: 18px;
    @media (max-width: 992px) {
      display: none;
    }
  }
  .fa-icon {
    margin: 7px 5px 0 0;
  }
}

#switch-find-type-text {
  float: right;
  @media (max-width: 992px) {
    float: none;
    text-align: center;
  }
  width: 100%;
  max-width: 42px;
  margin-top: 2px;
  line-height: 1.25em;
}

#results-count {
  background-color: #ccc;
  text-align: right;
  padding-top: ($grid-gutter-width / 2);

  @include media-breakpoint-up(md) {
    background-color: transparent;
    float: right;
    width: auto;
    padding: 2px 0px 0px 0px;
    margin-top: -54px;
    height: 54px;
  }

  .col-form-label {
    display: inline-block;
  }

  select {
    text-align: left;
  }

  .custom-select {
    width: auto;
  }
}

.list-results {
  z-index: 20;
  position: relative;

  background-color: #ccc;
  padding: 0 20px 20px 20px;
  height: 625px;
  overflow: auto;
  .letter {
    position: absolute;
    left: 13px;
    top: 5px;
    color: #000;
    font-size: .8em;
    text-align: center;
    width: 10px;
  }
  .letter.white {
    color: #fff;
  }
  .fuel-pin {
    width: 29px;
    height: 39px;
    margin: -2px 13px 10px 3px;
  }
  .fuel-marker {
    width: 15px;
    height: 15px;
    margin: 0 10px 10px 0;
  }
  a.station-link {
    color: #333;
    &:hover {
      text-decoration: none;
    }
  }

  .station {
    word-wrap: break-word;
    line-height: 1.25;
    padding: 10px;
    margin-bottom: 15px;
    background-color: #fff;
    border: 1px solid #fff;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    &.station-selected, &:hover {
      background-color: #eee;
      border: 1px solid #999;
      cursor: pointer;
      .station-name {
        color: #2B6597;
      }
    }
    &.station-selected {
      background-color: #e3e8e8;
      border: 1px solid #62b378;
    }
    .distance {
      padding-left: 4px;
      text-align: right;
    }
    .route-distance {
      margin-top: 10px;
    }
    .station-name {
      color: #337ab7;
    }
  }

  .page-count {
    text-align: center;
  }
}

.stations-error {
  padding-bottom: 5px;
}

// Manually apply gutter margins to location input. This allows for the fuel
// select menu to be a tad wider than the normal grid, so that the full labels are
// able to be visibile on the selected item.
.no-gutters > .location-inputs-col {
  @include media-breakpoint-up(md) {
    padding-right: 15px;
  }
}
</style>
